import React, { useState, useEffect } from "react";
import "./TransferHistory.css";

import { getCookieTransferHistory, clearItems, clearHistory } from "./helpers/Cookies";
import {getHistoryItems} from "./constants/Requests";
import { apiGetParamsReplace, endpoints } from "./constants/services.constants";

import { useNavigate } from "react-router-dom";
import { formatBytes, getDayMonthPretty } from "./helpers/Tools";

import { deleteUserAndTokenInStorage } from './helpers/AuthHelper/AuthHelperV2';

export default function TransferHistory() {
  const [openId, setOpenId] = useState(0); //opened is 1-indexed, 0 means no one is opened by default
  const [copied, setCopied] = useState(false);
  const [copiedId, setCopiedId] = useState(null);
  const [transfers, setTransfers] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

    // Fetch on component mount
    useEffect(() => {

    const fetchData = async () => {

    var guids = getCookieTransferHistory().map(h=>h.transferId);

      try {

        const json = await getHistoryItems(guids);

        setTransfers(json.map((t,i)=>({
          guid: t.guid,
          id:i+1,
          expires: t.expireDate,
          createdAt: t.created,
          name:t.title,
          files:t.files.map((f => ({
                  size: formatBytes(f.length),
                  name: f.name
          })))
        })));

      } catch (err) {
        setError(err.message);    // store error
      } finally {
        setLoading(false);        // stop loader
      }
    };

    fetchData();
  }, []); // empty array = run once on mount


  const handleToggle = (id) => {
    setOpenId((current) => (current === id ? null : id));
  };
  const handleCopy = (guid) => {

    navigator.clipboard.writeText(apiGetParamsReplace(endpoints.TRANSFER_FRONTEND_DOWNLOAD, guid));
    setCopiedId(guid);
    setCopied(true);
    setTimeout(() => setCopied(false), 1400);
  };




if(loading){

   return (
    <div className="success-ts-body"

    style={{
      backgroundImage: 'url("/assets/background.jpg")',
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh",
    }}

    >
      <div className="success-ts-page">
        <header className="success-ts-header">
         <a href="/">
            <img src="/assets/RepublicaTransfer-logo.png"  class="republica-logo" />
          </a>
        </header>

        <main className="success-ts-content">
          <div className="success-ts-card">
            <h1 className="success-ts-title">Fetching data</h1>            
            <div className="success-ts-name-row">
              <span className="success-ts-shipment-name">Stand by...</span>
            </div>          
          </div>
        </main>
      </div>
    </div>
   )
  }


  return (
    <div className="history-rt-page"

      style={{
        backgroundImage: 'url("/assets/background.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}
      
    >
      <header className="history-rt-header">
        <a href="/">
          <img src="assets/RepublicaTransfer-logo.png" class="republica-logo" />
        </a>
        <div className="logout-btn" onClick={()=>{deleteUserAndTokenInStorage();window.location.reload()}}>Log out</div>

        <button className="history-btn">Transfer history</button>
      </header>

      <main className="history-rt-main">
        <section className="history-rt-card">
          <div className="history-rt-card-header">
            <h1 className="history-rt-card-title">Transfer history</h1>
          </div>

          <div className="history-rt-group-list">
            {transfers.map((group) => {
              const isOpen = group.id === openId;
              return (
                <div
                  key={group.id}
                  className={`history-rt-group ${isOpen ? "history-rt-group--open" : ""}`}
                >
                  <button
                    className="history-rt-group-header"
                    onClick={() => handleToggle(group.id)}
                    type="button"
                  >
                    <div className="history-rt-group-header-left">
                      <span
                        className={`history-rt-chevron ${
                          isOpen ? "history-rt-chevron--open" : ""
                        }`}
                      >
                        ▸
                      </span>
                      <div className="history-rt-group-title-block">
                        <span className="history-rt-group-title">{group.name}</span>
                        <span className="history-rt-group-meta">
                          {group.files.length}, file(s) - created {getDayMonthPretty(group.createdAt)}, expires {getDayMonthPretty(group.expires)}
                        </span>
                      </div>
                    </div>

                    {copied && copiedId == group.guid && <p className="ts-copied">Copied!</p>}

                    <div className="history-rt-group-header-right">
                        <img className="copy-icon" width={15} src="assets/copy-icon.png"  onClick={(e) => { e.stopPropagation(); handleCopy(group.guid);}}/>         
                    </div>
                                
            
                  </button>

                  {isOpen && group.files.length > 0 && (
                    <div className="history-rt-file-list">
                      {group.files.map((file) => (
                      <div key={file.name} className="history-rt-file-row">
                        <div style={{marginLeft: 20}} className="history-rt-file-column">
                          <div className="history-rt-file-name">{file.name}</div>
                          <div className="history-rt-file-meta">({file.size})</div>
                        </div>
                      </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </section>
      </main>
    </div>
  );
}